/* lib/api/utmHit.js — публичный трекинг перехода по короткой ссылке UTM-метки. Отдельно от
 * клиента раздела (utm.js реэкспортирует): экран /r/:code живёт в главном чанке (первый экран
 * анонима), и импорт всего клиента «UTM-меток» оттуда возил бы его каждому входу в приложение.
 *
 * Фолбэк-трекинг перехода для роута /r/:code (когда в nginx нет `location ^~ /r/`).
 * БЕЗ unwrap: провал трекинга не должен превращаться в
 * исключение — экран перехода обязан увести человека дальше в любом случае,
 * а не показать ему ошибку трекинга. `to` — назначение ссылки (site/demo/buy/course);
 * `slug` — тариф ссылки «на покупку» (`/r/<код>/buy/<слаг>`) или курс ссылки «на
 * страницу курса» (`/r/<код>/course/<слаг>`), уходит только вместе с ними.
 * КУДА уводить, отвечает бэкенд полем `url` в `data` ответа: адрес лендинга живёт
 * в его настройках, а продаётся ли тариф и опубликован ли курс, знает только он
 * (снятый с продажи или с публикации — на регистрацию). apiFetch не бросает по
 * HTTP-кодам, так что вызывающему остаётся только страховка на отказ самого fetch.
 *
 * Тело — ОБЫЧНЫЙ ОБЪЕКТ, и это часть контракта, а не стиль. apiFetch шлёт
 * объект как JSON (`Content-Type: application/json`), а FormData — как
 * multipart-форму; эндпоинт же принимает ТОЛЬКО JSON (`parser_classes=[JSONParser]`
 * на бэке) и на форму ответит 415. Форма отсюда убрана не ради аккуратности:
 * «простой» запрос с формой браузер шлёт БЕЗ предварительного preflight, CORS
 * его не останавливает (он запрещает читать ответ, а не отправлять запрос), а
 * CSRF на публичном входе выключен вместе с аутентификацией — то есть чужая
 * страница могла бы накручивать переходы по чужой метке. JSON делает запрос
 * «непростым», браузер обязан сделать preflight, и кросс-сайтовый вызов не
 * доходит. Никаких FormData/URLSearchParams здесь — молча сломает и то, и другое. */

import { apiFetch } from './client.js';

export const trackUtmHit = (code, to, slug) =>
  apiFetch('/api/utm/hit/', {
    method: 'POST', body: { code, to: to || undefined, slug: slug || undefined },
  });
